import { useNavigate } from 'react-router-dom';
import { Archive, ArrowRight, Box, Download, FolderOpen, Upload, Workflow } from 'lucide-react';

const INFO_CARDS = [
  {
    title: '补素材',
    text: '角色、场景、道具和动作参考，都在当前画布的缺口卡里处理。',
    icon: Upload,
  },
  {
    title: '项目素材',
    text: '上传和生成结果自动归到当前项目，不再单独维护复杂资产中心。',
    icon: Box,
  },
  {
    title: '交付下载',
    text: '项目完成后，直接在画布里导出素材包、镜序清单和交付包。',
    icon: Download,
  },
];

export default function AssetManagerPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#f6f3ec] px-6 py-8 text-stone-900 dark:bg-[#0e0e10] dark:text-gray-100">
      <div className="mx-auto max-w-4xl">
        <div className="rounded-[28px] border border-[#ded6c8] bg-[#fbfaf6] p-7 shadow-sm dark:border-white/[0.06] dark:bg-[#15151b]">
          <div className="flex flex-wrap items-start justify-between gap-5">
            <div>
              <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-[#ded6c8] bg-white px-3 py-1.5 text-[12px] font-medium text-stone-500 dark:border-white/[0.08] dark:bg-white/[0.04] dark:text-gray-400">
                <Archive size={13} />
                已降级为项目素材资料夹
              </div>
              <h1 className="text-[26px] font-bold tracking-tight">素材资料夹</h1>
              <p className="mt-3 max-w-2xl text-[14px] leading-6 text-stone-500 dark:text-gray-400">
                小影现在采用更简单的画布工作流：缺角色、场景、道具或参考文件时，直接在无限画布里上传或让小影生成。这里不再作为图片/视频生产中心。
              </p>
            </div>
            <button
              onClick={() => navigate('/canvas')}
              className="inline-flex items-center gap-2 rounded-2xl bg-[#8c7db0] px-4 py-3 text-[13px] font-semibold text-white shadow-sm transition hover:bg-[#7d6ca3]"
            >
              <Workflow size={15} />
              进入无限画布
              <ArrowRight size={14} />
            </button>
          </div>

          <div className="mt-7 grid gap-3 md:grid-cols-3">
            {INFO_CARDS.map(card => {
              const Icon = card.icon;
              return (
                <div key={card.title} className="rounded-2xl border border-[#e4dccf] bg-white/70 p-4 dark:border-white/[0.06] dark:bg-white/[0.03]">
                  <Icon size={18} className="text-[#7769a0]" />
                  <p className="mt-3 text-[14px] font-semibold">{card.title}</p>
                  <p className="mt-1 text-[12px] leading-5 text-stone-500 dark:text-gray-400">{card.text}</p>
                </div>
              );
            })}
          </div>

          <div className="mt-7 rounded-2xl border border-dashed border-[#d6cbbb] bg-[#f6f1e7] p-4 dark:border-white/[0.08] dark:bg-white/[0.03]">
            <div className="flex items-start gap-3">
              <FolderOpen size={18} className="mt-0.5 text-[#7769a0]" />
              <div>
                <p className="text-[13px] font-semibold">后续规则</p>
                <p className="mt-1 text-[12px] leading-5 text-stone-500 dark:text-gray-400">
                  上传素材、生成参考图、首帧、视频片段和交付包都会围绕当前画布完成；素材资料夹只保留查看、复用和下载能力，不再承载主生产流程。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
